module.exports = __webpack_public_path__ + "static/media/1POLICY47.f416a847.jpg";